import * as React from 'react';
import './SellingFeatureRow.scss';
import { childClassClosure, ClassableProps, baseClassAnd } from '@jcharlesworthuk/your-mum-core/dist/functions';
import LinkButton from '../buttons/LinkButton';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { useState } from 'react';
import { useRef } from 'react';
import SurveyEditorWithTextScreenDemo from '../screendemos/SurveyEditorWithTextScreenDemo';
import WeeklyReportScreenDemo from '../screendemos/WeeklyReportScreenDemo';
import SomethingWrongScreenDemo from '../screendemos/SomethingWrongScreenDemo';


const baseClass = 'feature-row';
const childClass = childClassClosure(baseClass);

type Props = ClassableProps & {
    title: string,
    iconPath: string,
    imgSrc?: string,
    demoName?: 'survey-editor-with-text' | 'weekly-report' | 'something-wrong';
    direction?: 'ltr' | 'rtl',
    children?: JSX.Element | JSX.Element[];
    ctaText?: string;
    ctaLinkTo?: string;
}

const SellingFeatureRow: React.FunctionComponent<Props> = (props: Props) => {
    const [scrolled, setScrolled] = useState(false);
    const objectRef = useRef<HTMLDivElement>(null);

    useScrollPosition(({ currPos, prevPos }) => {
        if (currPos.y > prevPos.y) return;
    const isScrolledTo = objectRef.current &&
            window.innerHeight - objectRef.current.getBoundingClientRect().top > 300
            && !objectRef.current.classList.contains('shown');
        if (isScrolledTo) {
            objectRef.current.classList.add('shown');
            setScrolled(isScrolledTo);
        }
    }, []);

    return <section className={baseClassAnd(baseClass, props, props.direction === 'rtl' ? 'rtl' : 'ltr', scrolled ? 'scrolled' : 'not-scrolled')}  ref={objectRef}>
        <div className={childClass('detail', scrolled ? 'scrolled' : 'not-scrolled')}>
            <div className={childClass('detail-icon')}>
                <img className={childClass('icon')} src={props.iconPath} alt={props.title} />
            </div>
            <h2 className={childClass('title')}>{props.title}</h2>
            <p className={childClass('content')}>
                {props.children}
            </p>
            {props.ctaText && <LinkButton className={childClass('cta')} to={props.ctaLinkTo || '/account/register'} label={props.ctaText} style='secondary' /> }
        </div>
        <div className={childClass('image-block')}>
            {props.imgSrc && <img className={childClass('img')} src={props.imgSrc} alt={props.title} />}
            {props.demoName === 'survey-editor-with-text' && <SurveyEditorWithTextScreenDemo animate={scrolled} />}
            {props.demoName === 'weekly-report' && <WeeklyReportScreenDemo animate={scrolled} />}
            {props.demoName === 'something-wrong' && <SomethingWrongScreenDemo animate={scrolled} />}
        </div>
    </section>
}
export default SellingFeatureRow;
